// /var/www/oszczedzam/client/src/firebase.js
import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getDatabase } from 'firebase/database';

const firebaseConfig = {
    apiKey: "AIzaSyBfgbvzhiSbqng7j3Lm98JDlcMgSB-PrAA",
    authDomain: "oszczedzam-92f50.firebaseapp.com",
    projectId: "oszczedzam-92f50",
    storageBucket: "oszczedzam-92f50.firebasestorage.app",
    messagingSenderId: "936788293468",
    appId: "1:936788293468:web:7892620ec3ac176fc47399",
    measurementId: "G-5J5PE8P8L0",
    databaseURL: "https://oszczedzam-92f50-default-rtdb.europe-west1.firebasedatabase.app"
};

// Inicjalizacja Firebase
const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const database = getDatabase(app);

export { app, auth, database };
